var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (e) {
  "function" == typeof define && define.amd ? define(e) : e();
}(function () {
  "use strict";

  function e() {}

  function t(e) {
    return e();
  }

  function n() {
    return Object.create(null);
  }

  function o(e) {
    e.forEach(t);
  }

  function r(e) {
    return "function" == typeof e;
  }

  function i(e, t) {
    return e != e ? t == t : e !== t;
  }

  function c(e, t) {
    e.appendChild(t);
  }

  function s(e, t, n) {
    e.insertBefore(t, n || null);
  }

  function l(e) {
    e.parentNode.removeChild(e);
  }

  function a(e) {
    return document.createElement(e);
  }

  function d(e) {
    return document.createTextNode(e);
  }

  function u() {
    return d(" ");
  }

  function p(e, t, n, o) {
    return e.addEventListener(t, n, o), function () {
      return e.removeEventListener(t, n, o);
    };
  }

  function h(e, t, n) {
    null == n ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
  }

  function f(e, t, n) {
    e.classList[n ? "add" : "remove"](t);
  }

  function m(e) {
    var t = {};

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n = _step.value;
        t[_n.name] = _n.value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return t;
  }

  var g;

  function b(e) {
    g = e;
  }

  var w = [],
      $ = [],
      y = [],
      x = [],
      v = Promise.resolve();
  var C = !1;

  function _(e) {
    y.push(e);
  }

  var S = !1;
  var k = new Set();

  function N() {
    if (!S) {
      S = !0;

      do {
        for (var _e = 0; _e < w.length; _e += 1) {
          var _t = w[_e];
          b(_t), T(_t.$$);
        }

        for (b(null), w.length = 0; $.length;) {
          $.pop()();
        }

        for (var _e2 = 0; _e2 < y.length; _e2 += 1) {
          var _t2 = y[_e2];
          k.has(_t2) || (k.add(_t2), _t2());
        }

        y.length = 0;
      } while (w.length);

      for (; x.length;) {
        x.pop()();
      }

      C = !1, S = !1, k.clear();
    }
  }

  function T(e) {
    if (null !== e.fragment) {
      e.update(), o(e.before_update);
      var _t3 = e.dirty;
      e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, _t3), e.after_update.forEach(_);
    }
  }

  var E = new Set();
  var R = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : global;

  function A(e, t) {
    -1 === e.$$.dirty[0] && (w.push(e), C || (C = !0, v.then(N)), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
  }

  function z(i, c, s, a, d, u, p) {
    var h = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [-1];
    var f = g;
    b(i);
    var m = i.$$ = {
      fragment: null,
      ctx: null,
      props: u,
      update: e,
      not_equal: d,
      bound: n(),
      on_mount: [],
      on_destroy: [],
      on_disconnect: [],
      before_update: [],
      after_update: [],
      context: new Map(c.context || (f ? f.$$.context : [])),
      callbacks: n(),
      dirty: h,
      skip_bound: !1,
      root: c.target || f.$$.root
    };
    p && p(m.root);
    var w = !1;

    if (m.ctx = s ? s(i, c.props || {}, function (e, t) {
      var o = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : t;
      return m.ctx && d(m.ctx[e], m.ctx[e] = o) && (!m.skip_bound && m.bound[e] && m.bound[e](o), w && A(i, e)), t;
    }) : [], m.update(), w = !0, o(m.before_update), m.fragment = !!a && a(m.ctx), c.target) {
      if (c.hydrate) {
        var _e3 = function (e) {
          return Array.from(e.childNodes);
        }(c.target);

        m.fragment && m.fragment.l(_e3), _e3.forEach(l);
      } else m.fragment && m.fragment.c();

      c.intro && ($ = i.$$.fragment) && $.i && (E.delete($), $.i(y)), function (e, n, i, c) {
        var _e$$$ = e.$$,
            s = _e$$$.fragment,
            l = _e$$$.on_mount,
            a = _e$$$.on_destroy,
            d = _e$$$.after_update;
        s && s.m(n, i), c || _(function () {
          var n = l.map(t).filter(r);
          a ? a.push.apply(a, _toConsumableArray(n)) : o(n), e.$$.on_mount = [];
        }), d.forEach(_);
      }(i, c.target, c.anchor, c.customElement), N();
    }

    var $, y;
    b(f);
  }

  var B;
  var D, L, H, M, P, q, F;
  "function" == typeof HTMLElement && (B = /*#__PURE__*/function (_HTMLElement) {
    _inherits(B, _HTMLElement);

    function B() {
      var _this;

      _classCallCheck(this, B);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(B).call(this)), _this.attachShadow({
        mode: "open"
      });
      return _this;
    }

    _createClass(B, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var e = this.$$.on_mount;
        this.$$.on_disconnect = e.map(t).filter(r);

        for (var _e4 in this.$$.slotted) {
          this.appendChild(this.$$.slotted[_e4]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(e, t, n) {
        this[e] = n;
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        o(this.$$.on_disconnect);
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        !function (e, t) {
          var n = e.$$;
          null !== n.fragment && (o(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
        }(this, 1), this.$destroy = e;
      }
    }, {
      key: "$on",
      value: function $on(e, t) {
        var n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
        return n.push(t), function () {
          var e = n.indexOf(t);
          -1 !== e && n.splice(e, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(e) {
        var t;
        this.$$set && (t = e, 0 !== Object.keys(t).length) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
      }
    }]);

    return B;
  }(_wrapNativeSuper(HTMLElement))), function (e) {
    e[e.Failed = 0] = "Failed", e[e.NoBrowserSupport = 1] = "NoBrowserSupport", e[e.NoAudioConsent = 2] = "NoAudioConsent", e[e.__UnrecoverableErrors = 3] = "__UnrecoverableErrors", e[e.Disconnected = 4] = "Disconnected", e[e.Disconnecting = 5] = "Disconnecting", e[e.Connecting = 6] = "Connecting", e[e.Preinitialized = 7] = "Preinitialized", e[e.Initializing = 8] = "Initializing", e[e.Connected = 9] = "Connected", e[e.Stopping = 10] = "Stopping", e[e.Starting = 11] = "Starting", e[e.Recording = 12] = "Recording";
  }(D || (D = {})), function (e) {
    e.SpeechlyFirstConnect = "SpeechlyFirstConnect";
  }(L || (L = {})), function (e) {
    e.speechlypoweron = "speechlypoweron", e.holdstart = "holdstart", e.holdend = "holdend", e.speechstate = "speechstate", e.speechsegment = "speechsegment", e.speechhandled = "speechhandled", e.showhint = "showhint", e.transcriptdrawerhint = "hint", e.speechlyintroready = "speechlyintroready", e.speechlyintroclosed = "speechlyintroclosed";
  }(H || (H = {})), function (e) {
    e.Mic = "mic", e.MicActive = "micactive", e.Error = "error", e.Denied = "denied";
  }(M || (M = {})), function (e) {
    e.Hold = "hold", e.Click = "click", e.Noninteractive = "noninteractive";
  }(P || (P = {})), function (e) {
    e.None = "none", e.Connecting = "connecting", e.Busy = "busy";
  }(q || (q = {})), function (e) {
    e.None = "none", e.Whirl = "whirl";
  }(F || (F = {})), D.Disconnected, D.Disconnecting, D.Connecting, D.Preinitialized, D.Initializing, D.Connected, D.Starting, D.Recording, D.Stopping, D.Failed, D.NoBrowserSupport, D.NoAudioConsent;
  var I = R.window;

  function j(e) {
    var t,
        n,
        o,
        r,
        i,
        d,
        h,
        f,
        _m = e[1] === K && O(),
        g = e[1] === D.NoAudioConsent && U(),
        b = e[1] === D.NoBrowserSupport && W(),
        w = e[1] === Q && G();

    return {
      c: function c() {
        t = a("errorDiv"), n = a("errorLeft"), n.textContent = "×", o = u(), _m && _m.c(), r = u(), g && g.c(), i = u(), b && b.c(), d = u(), w && w.c();
      },
      m: function m(l, a) {
        s(l, t, a), c(t, n), c(t, o), _m && _m.m(t, null), c(t, r), g && g.m(t, null), c(t, i), b && b.m(t, null), c(t, d), w && w.m(t, null), h || (f = p(n, "click", e[3]), h = !0);
      },
      p: function p(e, n) {
        e[1] === K ? _m ? _m.p(e, n) : (_m = O(), _m.c(), _m.m(t, r)) : _m && (_m.d(1), _m = null), e[1] === D.NoAudioConsent ? g ? g.p(e, n) : (g = U(), g.c(), g.m(t, i)) : g && (g.d(1), g = null), e[1] === D.NoBrowserSupport ? b || (b = W(), b.c(), b.m(t, d)) : b && (b.d(1), b = null), e[1] === Q ? w ? w.p(e, n) : (w = G(), w.c(), w.m(t, null)) : w && (w.d(1), w = null);
      },
      d: function d(e) {
        e && l(t), _m && _m.d(), g && g.d(), b && b.d(), w && w.d(), h = !1, f();
      }
    };
  }

  function O(t) {
    var n, o, r, i, p, f, _m2, g, b, w;

    return {
      c: function c() {
        n = a("errorRight"), o = a("h1"), o.textContent = "Failed to connect Speechly", r = u(), i = a("p"), i.textContent = "Please check that Speechly application id has been successfully deployed.", p = u(), f = a("p"), _m2 = a("a"), _m2.textContent = "Troubleshooting", g = d("\n                \n            "), b = a("a"), w = d("Reload"), h(_m2, "href", "https://docs.speechly.com/faq/#error-invalid-app-id"), h(b, "href", window.location.href);
      },
      m: function m(e, t) {
        s(e, n, t), c(n, o), c(n, r), c(n, i), c(n, p), c(n, f), c(f, _m2), c(f, g), c(f, b), c(b, w);
      },
      p: e,
      d: function d(e) {
        e && l(n);
      }
    };
  }

  function U(t) {
    var n, o, r, i, p, f, _m3, g, b, w;

    return {
      c: function c() {
        n = a("errorRight"), o = a("h1"), o.textContent = "No Mic Permission", r = u(), i = a("p"), i.textContent = "To use the voice interface, please allow your web browser access the\n            microphone and reload.", p = u(), f = a("p"), _m3 = a("a"), _m3.textContent = "Troubleshooting", g = d("\n                \n            "), b = a("a"), w = d("Reload"), h(_m3, "href", "https://docs.speechly.com/faq/#error-no-audio-consent"), h(b, "href", window.location.href);
      },
      m: function m(e, t) {
        s(e, n, t), c(n, o), c(n, r), c(n, i), c(n, p), c(n, f), c(f, _m3), c(f, g), c(f, b), c(b, w);
      },
      p: e,
      d: function d(e) {
        e && l(n);
      }
    };
  }

  function W(e) {
    var t;
    return {
      c: function c() {
        t = a("errorRight"), t.innerHTML = '<h1>Unsupported Browser</h1> \n          <p>To use the voice interface, please visit this site using a supported\n            browser.</p> \n          <p><a href="https://docs.speechly.com/client-libraries/supported-browsers/#error-no-browser-support">Troubleshooting</a></p>';
      },
      m: function m(e, n) {
        s(e, t, n);
      },
      d: function d(e) {
        e && l(t);
      }
    };
  }

  function G(t) {
    var n, o, r, i, p, f, _m4, g, b, w;

    return {
      c: function c() {
        n = a("errorRight"), o = a("h1"), o.textContent = "HTTPS Required", r = u(), i = a("p"), i.textContent = "To use the voice interface, please visit this site using the secure\n            https:// protocol.", p = u(), f = a("p"), _m4 = a("a"), _m4.textContent = "Troubleshooting", g = d("\n                \n            "), b = a("a"), w = d("Try with HTTPS"), h(_m4, "href", "https://docs.speechly.com/faq/#error-https-required"), h(b, "href", window.location.href.replace(/^http(?!s)/, "https"));
      },
      m: function m(e, t) {
        s(e, n, t), c(n, o), c(n, r), c(n, i), c(n, p), c(n, f), c(f, _m4), c(f, g), c(f, b), c(b, w);
      },
      p: e,
      d: function d(e) {
        e && l(n);
      }
    };
  }

  function J(t) {
    var n,
        o,
        r,
        i,
        _d,
        _m5 = t[1] && j(t);

    return {
      c: function c() {
        n = a("link"), o = u(), r = a("main"), _m5 && _m5.c(), this.c = e, h(n, "href", "https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@700&display=swap"), h(n, "rel", "stylesheet"), f(r, "bottom", "bottom" === t[0]);
      },
      m: function m(e, l) {
        c(document.head, n), s(e, o, l), s(e, r, l), _m5 && _m5.m(r, null), i || (_d = p(I, "message", t[2]), i = !0);
      },
      p: function p(e, _ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            t = _ref2[0];

        e[1] ? _m5 ? _m5.p(e, t) : (_m5 = j(e), _m5.c(), _m5.m(r, null)) : _m5 && (_m5.d(1), _m5 = null), 1 & t && f(r, "bottom", "bottom" === e[0]);
      },
      i: e,
      o: e,
      d: function d(e) {
        l(n), e && l(o), e && l(r), _m5 && _m5.d(), i = !1, _d();
      }
    };
  }

  var K = "InvaldAppId",
      Q = "HttpsRequired";

  function V(e, t, n) {
    var _t$placement = t.placement,
        o = _t$placement === void 0 ? null : _t$placement;
    var r = null;

    var i = function i(e) {
      var t, o;

      switch (e) {
        case D.Failed:
          n(1, r = K);
          break;

        case D.NoAudioConsent:
        case D.NoBrowserSupport:
          if ("https:" !== (null === (t = null === window || void 0 === window ? void 0 : window.location) || void 0 === t ? void 0 : t.protocol) && "localhost" !== (o = window.location.hostname) && "[::1]" !== o && null === o.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) {
            n(1, r = Q);
            break;
          }

          n(1, r = e);
      }
    };

    return e.$$set = function (e) {
      "placement" in e && n(0, o = e.placement);
    }, [o, r, function (e) {
      if (e.data.type === H.holdstart) i(e.data.state);
    }, function () {
      n(1, r = null);
    }];
  }

  var X = /*#__PURE__*/function (_B) {
    _inherits(X, _B);

    function X(e) {
      var _this2;

      _classCallCheck(this, X);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(X).call(this)), _this2.shadowRoot.innerHTML = "<style>main.bottom{position:fixed;bottom:0;left:0;right:0;min-height:10em;z-index:51;user-select:none;pointer-events:none}errorDiv{box-sizing:border-box;position:relative;width:100%;min-height:10em;background-color:white;user-select:text;pointer-events:all;color:black;display:flex;box-shadow:0 0 8px #00000040;flex-direction:row}errorLeft{box-sizing:border-box;width:2rem;background-color:red;padding:0.2rem 0.2rem;color:#ffffff;display:flex;flex-direction:column;align-items:center;justify-content:start;font-size:1.5rem;cursor:pointer}errorRight{background-color:white;padding:1rem 3rem 1rem 1rem;overflow:auto;flex-grow:1}h1{font-size:1.5rem;margin:0;padding:0 0 0.5rem 0;font-family:'Saira Condensed', sans-serif;text-transform:uppercase}p{margin:0;padding:0 0 0.5rem 0;color:#999}a{color:#000}</style>", z(_assertThisInitialized(_assertThisInitialized(_this2)), {
        target: _this2.shadowRoot,
        props: m(_this2.attributes),
        customElement: !0
      }, V, J, i, {
        placement: 0
      }, null), e && (e.target && s(e.target, _assertThisInitialized(_assertThisInitialized(_this2)), e.anchor), e.props && (_this2.$set(e.props), N()));
      return _this2;
    }

    _createClass(X, [{
      key: "placement",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(e) {
        this.$$set({
          placement: e
        }), N();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["placement"];
      }
    }]);

    return X;
  }(B);

  customElements.get("error-panel") ? console.warn("Skipping re-defining customElement error-panel") : customElements.define("error-panel", X);
});